import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = (n) => (_pushScopeId("data-v-421d0ebc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "sidebar-logo"
};
const _hoisted_2 = {
    key: 0,
    src: _imports_0,
    alt: "Surtimotos"
};
const _hoisted_3 = {
    key: 1,
    class: "logo-text"
};
const _hoisted_4 = { class: "nav" };
const _hoisted_5 = ["title"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-pie-chart" }, null, -1 /* HOISTED */));
const _hoisted_7 = { key: 0 };
const _hoisted_8 = ["title"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart" }, null, -1 /* HOISTED */));
const _hoisted_10 = { key: 0 };
const _hoisted_11 = ["title"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-package" }, null, -1 /* HOISTED */));
const _hoisted_13 = { key: 0 };
const _hoisted_14 = ["title"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-users" }, null, -1 /* HOISTED */));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = ["title"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-delivery" }, null, -1 /* HOISTED */));
const _hoisted_19 = { key: 0 };
const _hoisted_20 = ["title"];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-apartment" }, null, -1 /* HOISTED */));
const _hoisted_22 = { key: 0 };
const _hoisted_23 = ["title"];
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart-full" }, null, -1 /* HOISTED */));
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
    key: 0,
    class: "submenu"
};
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart-full" }, null, -1 /* HOISTED */));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Ventas Retail", -1 /* HOISTED */));
const _hoisted_30 = [
    _hoisted_27,
    _hoisted_28,
    _hoisted_29
];
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-printer" }, null, -1 /* HOISTED */));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Comandas Retail", -1 /* HOISTED */));
const _hoisted_34 = [
    _hoisted_31,
    _hoisted_32,
    _hoisted_33
];
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-coin" }, null, -1 /* HOISTED */));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Caja / Checkout", -1 /* HOISTED */));
const _hoisted_38 = [
    _hoisted_35,
    _hoisted_36,
    _hoisted_37
];
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "submenu-dot pulse-red-anim",
    style: { "background": "#ef4444", "box-shadow": "0 0 8px #ef4444" }
}, null, -1 /* HOISTED */));
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-pulse" }, null, -1 /* HOISTED */));
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Monitor Despacho", -1 /* HOISTED */));
const _hoisted_42 = [
    _hoisted_39,
    _hoisted_40,
    _hoisted_41
];
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-revenue" }, null, -1 /* HOISTED */));
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Notas de Crédito", -1 /* HOISTED */));
const _hoisted_46 = [
    _hoisted_43,
    _hoisted_44,
    _hoisted_45
];
const _hoisted_47 = ["title"];
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-briefcase" }, null, -1 /* HOISTED */));
const _hoisted_49 = { key: 0 };
const _hoisted_50 = {
    key: 0,
    class: "submenu"
};
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-credit-cards" }, null, -1 /* HOISTED */));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Aprobar Pagos", -1 /* HOISTED */));
const _hoisted_54 = [
    _hoisted_51,
    _hoisted_52,
    _hoisted_53
];
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-hourglass" }, null, -1 /* HOISTED */));
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Pedidos", -1 /* HOISTED */));
const _hoisted_58 = [
    _hoisted_55,
    _hoisted_56,
    _hoisted_57
];
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-archive" }, null, -1 /* HOISTED */));
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Historial Pagos", -1 /* HOISTED */));
const _hoisted_62 = [
    _hoisted_59,
    _hoisted_60,
    _hoisted_61
];
const _hoisted_63 = ["title"];
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart-full" }, null, -1 /* HOISTED */));
const _hoisted_65 = { key: 0 };
const _hoisted_66 = ["title"];
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-tag" }, null, -1 /* HOISTED */));
const _hoisted_68 = { key: 0 };
const _hoisted_69 = ["title"];
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-home" }, null, -1 /* HOISTED */));
const _hoisted_71 = { key: 0 };
const _hoisted_72 = ["title"];
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cog" }, null, -1 /* HOISTED */));
const _hoisted_74 = { key: 0 };
const _hoisted_75 = {
    key: 0,
    class: "submenu"
};
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-hammer" }, null, -1 /* HOISTED */));
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Repuestos", -1 /* HOISTED */));
const _hoisted_79 = [
    _hoisted_76,
    _hoisted_77,
    _hoisted_78
];
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-reload" }, null, -1 /* HOISTED */));
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Equivalentes", -1 /* HOISTED */));
const _hoisted_83 = [
    _hoisted_80,
    _hoisted_81,
    _hoisted_82
];
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-list" }, null, -1 /* HOISTED */));
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Desplegables", -1 /* HOISTED */));
const _hoisted_87 = [
    _hoisted_84,
    _hoisted_85,
    _hoisted_86
];
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-map-marker" }, null, -1 /* HOISTED */));
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Dptos.", -1 /* HOISTED */));
const _hoisted_91 = [
    _hoisted_88,
    _hoisted_89,
    _hoisted_90
];
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-tag" }, null, -1 /* HOISTED */));
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Categorías", -1 /* HOISTED */));
const _hoisted_95 = [
    _hoisted_92,
    _hoisted_93,
    _hoisted_94
];
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-credit-cards" }, null, -1 /* HOISTED */));
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Instru. Pago", -1 /* HOISTED */));
const _hoisted_99 = [
    _hoisted_96,
    _hoisted_97,
    _hoisted_98
];
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-user" }, null, -1 /* HOISTED */));
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Usuarios", -1 /* HOISTED */));
const _hoisted_103 = [
    _hoisted_100,
    _hoisted_101,
    _hoisted_102
];
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-shield" }, null, -1 /* HOISTED */));
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Roles", -1 /* HOISTED */));
const _hoisted_107 = [
    _hoisted_104,
    _hoisted_105,
    _hoisted_106
];
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "submenu-dot" }, null, -1 /* HOISTED */));
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cogs" }, null, -1 /* HOISTED */));
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Configuración Sistema", -1 /* HOISTED */));
const _hoisted_111 = [
    _hoisted_108,
    _hoisted_109,
    _hoisted_110
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        ($setup.isMobileOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sidebar-overlay",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($setup.closeMobile && $setup.closeMobile(...args)))
            }))
            : _createCommentVNode("v-if", true),
        _createElementVNode("aside", {
            class: _normalizeClass(['sidebar', { collapsed: $setup.isCollapsed, 'mobile-open': $setup.isMobileOpen }])
        }, [
            _createElementVNode("div", {
                class: "sidebar-toggle",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => ($setup.toggleCollapse && $setup.toggleCollapse(...args)))
            }, [
                _createElementVNode("i", {
                    class: _normalizeClass($setup.isCollapsed ? 'lni lni-chevron-right' : 'lni lni-chevron-left')
                }, null, 2 /* CLASS */)
            ]),
            (!$setup.isCollapsed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    ($setup.logoExists)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, "SURTIMOTOS"))
                ]))
                : _createCommentVNode("v-if", true),
            _createElementVNode("nav", _hoisted_4, [
                _createElementVNode("ul", null, [
                    _createCommentVNode(" Dashboard "),
                    ($setup.can($setup.P.INDICADORES.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: _normalizeClass({ active: $setup.isActive('/panel') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = ($event) => ($setup.goTo('/panel'))),
                                title: $setup.isCollapsed ? 'Indicadores' : ''
                            }, [
                                _hoisted_6,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Indicadores"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_5)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Pedidos propios "),
                    ($setup.can($setup.P.PEDIDOS.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 1,
                            class: _normalizeClass({ active: $setup.isActive('/panel/pedidos') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[3] || (_cache[3] = ($event) => ($setup.goTo('/panel/pedidos'))),
                                title: $setup.isCollapsed ? 'Pedidos' : ''
                            }, [
                                _hoisted_9,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Pedidos"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_8)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Productos (catálogo admin) "),
                    ($setup.can($setup.P.PRODUCTOS.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 2,
                            class: _normalizeClass({ active: $setup.isActive('/panel/productos') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[4] || (_cache[4] = ($event) => ($setup.goTo('/panel/productos'))),
                                title: $setup.isCollapsed ? 'Productos' : ''
                            }, [
                                _hoisted_12,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Productos"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_11)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Clientes "),
                    ($setup.can($setup.P.CLIENTES.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 3,
                            class: _normalizeClass({ active: $setup.isActive('/panel/clientes') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[5] || (_cache[5] = ($event) => ($setup.goTo('/panel/clientes'))),
                                title: $setup.isCollapsed ? 'Clientes' : ''
                            }, [
                                _hoisted_15,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Clientes"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_14)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Proveedores "),
                    ($setup.can($setup.P.PROVEEDORES.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 4,
                            class: _normalizeClass({ active: $setup.isActive('/panel/proveedores') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[6] || (_cache[6] = ($event) => ($setup.goTo('/panel/proveedores'))),
                                title: $setup.isCollapsed ? 'Proveedores' : ''
                            }, [
                                _hoisted_18,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Proveedores"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_17)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Tiendas Retail Aliadas "),
                    ($setup.can($setup.P.RED_ALIADA.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 5,
                            class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/red-aliada') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[7] || (_cache[7] = ($event) => ($setup.goTo('/panel/mantenimiento/red-aliada'))),
                                title: $setup.isCollapsed ? 'Tiendas Aliadas' : ''
                            }, [
                                _hoisted_21,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Tiendas Aliadas"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_20)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 🛒 VENTAS "),
                    ($setup.canSeeVentas)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 6,
                            class: _normalizeClass({ 'has-submenu': true, 'submenu-open': $setup.showVentas && !$setup.isCollapsed })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => ($setup.isCollapsed ? $setup.goTo('/panel/ventas-retail') : $setup.toggleVentas()), ["prevent"])),
                                style: { "cursor": "pointer" },
                                title: $setup.isCollapsed ? 'Ventas' : ''
                            }, [
                                _hoisted_24,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Ventas"))
                                    : _createCommentVNode("v-if", true),
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 1,
                                        class: _normalizeClass([$setup.showVentas ? 'lni lni-chevron-up' : 'lni lni-chevron-down', "submenu-icon"])
                                    }, null, 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_23),
                            _createVNode(_Transition, { name: "submenu" }, {
                                default: _withCtx(() => [
                                    (($setup.showVentas || $setup.isInVentasSubmenu) && !$setup.isCollapsed)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                                            ($setup.can($setup.P.VENTAS_RETAIL.VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 0,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/ventas-retail') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[9] || (_cache[9] = ($event) => ($setup.goTo('/panel/ventas-retail')))
                                                    }, _hoisted_30)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.VENTAS_RETAIL.COMANDA))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 1,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/ventas-retail/comanda') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[10] || (_cache[10] = ($event) => ($setup.goTo('/panel/ventas-retail/comanda')))
                                                    }, _hoisted_34)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.VENTAS_RETAIL.CAJA))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 2,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/ventas-retail/caja') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[11] || (_cache[11] = ($event) => ($setup.goTo('/panel/ventas-retail/caja')))
                                                    }, _hoisted_38)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.VENTAS_RETAIL.EN_VIVO))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 3,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/ventas-retail/en-vivo') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[12] || (_cache[12] = ($event) => ($setup.goTo('/panel/ventas-retail/en-vivo')))
                                                    }, _hoisted_42)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.NOTAS_CREDITO.VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 4,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/notas-credito') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[13] || (_cache[13] = ($event) => ($setup.goTo('/panel/notas-credito')))
                                                    }, _hoisted_46)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 💼 GESTIÓN "),
                    ($setup.canSeeGestion)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 7,
                            class: _normalizeClass({ 'has-submenu': true, 'submenu-open': $setup.showGestion && !$setup.isCollapsed })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[14] || (_cache[14] = _withModifiers(($event) => ($setup.isCollapsed ? $setup.goTo('/panel/gestion/pedidos') : $setup.toggleGestion()), ["prevent"])),
                                style: { "cursor": "pointer" },
                                title: $setup.isCollapsed ? 'Gestión' : ''
                            }, [
                                _hoisted_48,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Gestión"))
                                    : _createCommentVNode("v-if", true),
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 1,
                                        class: _normalizeClass([$setup.showGestion ? 'lni lni-chevron-up' : 'lni lni-chevron-down', "submenu-icon"])
                                    }, null, 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_47),
                            _createVNode(_Transition, { name: "submenu" }, {
                                default: _withCtx(() => [
                                    (($setup.showGestion || $setup.isInGestionSubmenu) && !$setup.isCollapsed)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_50, [
                                            ($setup.can($setup.P.PAGOS.APPROVE))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 0,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/gestion/aprobar-pagos') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[15] || (_cache[15] = ($event) => ($setup.goTo('/panel/gestion/aprobar-pagos')))
                                                    }, _hoisted_54)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.PEDIDOS.MANAGE))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 1,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/gestion/pedidos') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[16] || (_cache[16] = ($event) => ($setup.goTo('/panel/gestion/pedidos')))
                                                    }, _hoisted_58)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.PAGOS.HISTORY))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 2,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/gestion/historial-pagos') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[17] || (_cache[17] = ($event) => ($setup.goTo('/panel/gestion/historial-pagos')))
                                                    }, _hoisted_62)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 🛒 COMPRAS "),
                    ($setup.can($setup.P.COMPRAS.PEDIDOS) || $setup.can($setup.P.COMPRAS.RECEPCION) || $setup.can($setup.P.COMPRAS.VERIFICACION) || $setup.can($setup.P.COMPRAS.TRANSFERENCIA))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 8,
                            class: _normalizeClass({ active: $setup.isActive('/panel/compras') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[18] || (_cache[18] = ($event) => ($setup.goTo('/panel/compras'))),
                                title: $setup.isCollapsed ? 'Compras / Recepción' : '',
                                style: { "cursor": "pointer" }
                            }, [
                                _hoisted_64,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Compras / Recepción"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_63)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 💲 PRECIOS Y PROMOCIONES "),
                    ($setup.can($setup.P.PRECIOS.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 9,
                            class: _normalizeClass({ active: $setup.isActive('/panel/precios') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[19] || (_cache[19] = ($event) => ($setup.goTo('/panel/precios'))),
                                title: $setup.isCollapsed ? 'Precios y Promociones' : ''
                            }, [
                                _hoisted_67,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Precios y Promociones"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_66)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 🏢 ALMACENES "),
                    ($setup.can($setup.P.ALMACENES.VIEW))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 10,
                            class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/almacenes') })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[20] || (_cache[20] = ($event) => ($setup.goTo('/panel/mantenimiento/almacenes'))),
                                title: $setup.isCollapsed ? 'Logística y Almacenes' : ''
                            }, [
                                _hoisted_70,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_71, "Logística / Almacenes"))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_69)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" ⚙️ MANTENIMIENTO "),
                    ($setup.canSeeMantenimiento)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 11,
                            class: _normalizeClass({ 'has-submenu': true, 'submenu-open': $setup.showMantenimiento && !$setup.isCollapsed })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[21] || (_cache[21] = _withModifiers(($event) => ($setup.isCollapsed ? $setup.goTo('/panel/mantenimiento/repuestos') : $setup.toggleMantenimiento()), ["prevent"])),
                                style: { "cursor": "pointer" },
                                title: $setup.isCollapsed ? 'Mantenimiento' : ''
                            }, [
                                _hoisted_73,
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Mantenimiento"))
                                    : _createCommentVNode("v-if", true),
                                (!$setup.isCollapsed)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 1,
                                        class: _normalizeClass([$setup.showMantenimiento ? 'lni lni-chevron-up' : 'lni lni-chevron-down', "submenu-icon"])
                                    }, null, 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_72),
                            _createVNode(_Transition, { name: "submenu" }, {
                                default: _withCtx(() => [
                                    (($setup.showMantenimiento || $setup.isInMantenimientoSubmenu) && !$setup.isCollapsed)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_75, [
                                            ($setup.can($setup.P.REPUESTOS.VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 0,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/repuestos') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[22] || (_cache[22] = ($event) => ($setup.goTo('/panel/mantenimiento/repuestos')))
                                                    }, _hoisted_79)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.EQUIVALENTES.VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 1,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/equivalentes') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[23] || (_cache[23] = ($event) => ($setup.goTo('/panel/mantenimiento/equivalentes')))
                                                    }, _hoisted_83)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.CONFIGURACION.DESPLEGABLES_VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 2,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/desplegables') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[24] || (_cache[24] = ($event) => ($setup.goTo('/panel/mantenimiento/desplegables')))
                                                    }, _hoisted_87)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.CONFIGURACION.DEPARTAMENTOS_VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 3,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/departamentos') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[25] || (_cache[25] = ($event) => ($setup.goTo('/panel/mantenimiento/departamentos')))
                                                    }, _hoisted_91)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.CONFIGURACION.CATEGORIAS_VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 4,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/categorias') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[26] || (_cache[26] = ($event) => ($setup.goTo('/panel/mantenimiento/categorias')))
                                                    }, _hoisted_95)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.CONFIGURACION.INSTRUMENTOS_PAGO_VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 5,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/instrumentos-pago') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[27] || (_cache[27] = ($event) => ($setup.goTo('/panel/mantenimiento/instrumentos-pago')))
                                                    }, _hoisted_99)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.USUARIOS.VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 6,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/usuarios') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[28] || (_cache[28] = ($event) => ($setup.goTo('/panel/mantenimiento/usuarios')))
                                                    }, _hoisted_103)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.ROLES.MANAGE))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 7,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/roles') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[29] || (_cache[29] = ($event) => ($setup.goTo('/panel/mantenimiento/roles')))
                                                    }, _hoisted_107)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.CONFIGURACION.SISTEMA_VIEW))
                                                ? (_openBlock(), _createElementBlock("li", {
                                                    key: 8,
                                                    class: _normalizeClass({ active: $setup.isActive('/panel/mantenimiento/configuracion-sistema') })
                                                }, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[30] || (_cache[30] = ($event) => ($setup.goTo('/panel/mantenimiento/configuracion-sistema')))
                                                    }, _hoisted_111)
                                                ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ], 2 /* CLASS */)
    ], 64 /* STABLE_FRAGMENT */));
}
